import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
export const SearchBar = (props)=>/*#__PURE__*/ _jsxs("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            props.runSearchQuery();
        },
        children: [
            /*#__PURE__*/ _jsx("label", {
                className: "form__label search__label title--m",
                htmlFor: props.id,
                children: "Zoek in de site"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "form__item--icon",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        id: props.id,
                        type: "text",
                        className: "form__input search__input",
                        placeholder: "Zoeken",
                        value: props.query,
                        autoFocus: true,
                        onChange: (e)=>props.updateSearchQuery(e.target.value)
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "submit",
                        className: "button button--primary button--arrow search__button",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "Zoeken"
                        })
                    }),
                    /*#__PURE__*/ _jsx("svg", {
                        className: "form__icon",
                        width: "20px",
                        height: "20px",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: "#icon--search-dnb"
                        })
                    })
                ]
            })
        ]
    });
